import { Module } from 'lib/vendor/terrific/Module';
import { Hook, Sandbox } from 'lib/vendor/terrific/Sandbox';
import { FilterConfig } from 'lib/sdx/gcr-pressrelease/GcrPressReleaseFilterConfig';
import * as jQuery from 'jquery';
import { NewsItem } from 'lib/sdx/gcr-pressrelease/GcrPressReleaseNewsItem';
import { headConfig } from 'lib/sdx/gcr-pressrelease/GcrPressReleaseSettings';
import { truncate } from 'lib/util/string';
import { ResultCard } from 'lib/sdx/gcr-pressrelease/ResultCard';

export const DATE_CONFIG_SHORT = {
	day : '2-digit',
	month : 'long',
	year : 'numeric',
} as const;

export const DATETIME_CONFIG = {
	day : '2-digit',
	hour : '2-digit',
	minute : '2-digit',
	month : 'long',
	year : 'numeric',
} as const;


export default class GcrNewsArchiveResults extends Module {
	private filter! : FilterConfig;
	private loadedResults = 0;
	private serviceUrl : string;
	private cardLayout = true;
	private items : NewsItem[] = [];
	private resultHolder : ResultCard;
	private lastHeading = '';

	constructor($ctx : JQuery, sandbox : Sandbox, id : number, modName : string) {
		super($ctx, sandbox, id, modName);
		this.serviceUrl = $ctx.data('service-url');
		this.resultHolder = new ResultCard(this.$ctx.find('.news-results')[0], this.$ctx.data('more-translation'));
	}

	public on(finished : Hook) {
		this.$ctx.find('.toolbar a.grid').on('click',
			() => this.changeLayout(true));
		this.$ctx.find('.toolbar a.list').on('click',
			() => this.changeLayout(false));
		this.$ctx.find('.news-show-more').on('click',
			() => this.load());
		finished();
	}

	/* Called by Tc.Module.GcrPressReleaseSearch */
	protected onUpdateSearchFilter(filter : FilterConfig) {
		// Filter object from search form
		this.filter = filter;
		// Limits and offset can be set via data attributes
		this.filter.limit = this.$ctx.data('limit') || 10;
		this.filter.offset = this.$ctx.data('offset') || 0;
		// Reset loaded results state
		this.loadedResults = 0;
		// Clear out the viewport
		this.resultHolder.clear();
		this.items = [];
		// Reset state variable
		this.lastHeading = '';

		this.load();
	}

	private hideLoadSpinner() {
		this.$ctx.find('.loader-spinner').addClass('hidden');
	}

	private showLoadSpinner() {
		this.$ctx.find('.loader-spinner').removeClass('hidden');
	}

	private hideBtnLoadMore() {
		this.$ctx.find('.news-show-more').addClass('hidden');
	}

	private showBtnLoadMore() {
		this.$ctx.find('.news-show-more').removeClass('hidden');
	}

	private disableBtnLoadMore() {
		this.$ctx.find('.news-show-more').addClass('disabled');
	}

	private enableBtnLoadMore() {
		this.$ctx.find('.news-show-more').removeClass('disabled');
	}

	private hideNoResults() {
		this.$ctx.find('.news-no-results').addClass('hidden');
	}

	private showNoResult() {
		this.$ctx.find('.news-no-results').removeClass('hidden');
	}

	private changeLayout(layoutCard : boolean) {
		this.cardLayout = layoutCard;
		if (this.cardLayout) {
			this.$ctx.find('.switch-layout').removeClass('show-list').addClass('show-grid');
		} else {
			this.$ctx.find('.switch-layout').addClass('show-list').removeClass('show-grid');
		}
		this.renderItems();
	}

	private load() {
		this.showLoadSpinner();
		this.hideNoResults();
		this.hideBtnLoadMore();
		this.disableBtnLoadMore();

		jQuery.post({
			data: this.filter,
			dataType: 'json',
			url: this.serviceUrl,
		})
			.always(this.hideLoadSpinner.bind(this))
			.always(this.showBtnLoadMore.bind(this))
			.always(this.enableBtnLoadMore.bind(this))
			.done(this.handleSuccess.bind(this))
			.fail(this.handleFailure.bind(this));
	}

	private handleSuccess(data : any) {
		if (data && data.results && data.results.length) {
			const items = data.results
				.map((item : any) => this.enrichItem(item));
			this.items = [...this.items, ...items];
			this.overrideDefaultCardLayout();
			this.renderItems();
			this.loadedResults += data.results.length;
			this.filter.offset = this.loadedResults;
		}
		// Did we load all results?
		if (data.lastResultSet) {
			this.hideBtnLoadMore();
			// Loaded no items at all?
			if (this.loadedResults === 0) {
				this.showNoResult();
			}
		}
	}

	private renderItems() {
		this.resultHolder.renderItems(this.items, this.cardLayout);
	}

	// Show list-view if ad-hoc tag is one of selected tags
	private overrideDefaultCardLayout() {
		const filterLimit = this.$ctx.data('limit') || 10;
		if (this.filter.section?.includes('gcr:pressRoom/section/adhoc') && this.loadedResults < filterLimit) {
			this.changeLayout(false);
		}
	}

	private enrichItem(data : any) : NewsItem {

		const lang = this.filter.lang;
		const itemDate = new Date(data.date);
		// Format the date string to locale (not supported by all UAs)
		const readableDate = itemDate.toLocaleDateString(lang, DATE_CONFIG_SHORT);
		const dateAndTime = itemDate.toLocaleDateString(lang, DATETIME_CONFIG);
		let monthHeading = itemDate.toLocaleDateString(lang, headConfig);
		// Make sure to write the month always in uppercase (needed for fr/it)
		monthHeading = monthHeading.charAt(0).toUpperCase() + monthHeading.substr(1);

		const maxLen = data.image || data.imageUrl ? 105 : 165;
		if (data.lead && data.lead.length > maxLen + 4) {
			data.lead = truncate(data.lead, maxLen + 4);
		}

		const item : NewsItem = {
			categories: data.categories,
			date: readableDate,
			dateAndTime,
			image: data.image,
			imageMobile: data.imageMobile,
			imageUrl: data.imageUrl,
			lead: data.lead,
			title: data.title,
			topics: data.topics,
			url: data.url,
		};

		// Only set month heading if not used before
		if(this.lastHeading !== monthHeading) {
			this.lastHeading = monthHeading;
			item.heading = monthHeading;
		}

		return item;
	}



	private handleFailure(error : any) {
		// Is there anything to show?
		this.log('failure', error);
		this.hideBtnLoadMore();
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/sdx/gcr-pressrelease/Tc.Module.GcrNewsArchiveResults.ts